import React from 'react'
import './Hero.css'
import profile_img from '../../assets/prash.jpg'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const Hero = () => {
  return (
    <div id='home ' className='hero'>
        <img src={profile_img} alt="" />
      <h1><span>I'm Prashant</span> , fullstack developer from India.</h1>
        <p>
          I am a web developer from UttarPradesh , India . Currently I am pursuing B.Tech Computer Science and Engineering second year.


        </p>
        <div className="hero-action">
          <div className="hero-connect">
          <AnchorLink className='anchor-link' offset={50} href='#contact'>Connect With me</AnchorLink>

          </div>
        <a href="/PrashantYadavCV.pdf" download target="_blank" rel="noopener noreferrer">
          <div className="hero-resume">My Resume</div>

          </a>
        </div>
    </div>
  )
}

export default Hero
